const TOKEN_KEY = 'projecttrack_token';
const SI_LOGIN_URL = process.env.REACT_APP_SI_LOGIN_URL || 'https://snowbirdindustries.us/login';

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

/**
 * If a `token` query param is present in the URL, save it and strip it
 * from the URL so it doesn't linger in the address bar or history.
 */
export function consumeTokenFromURL(): void {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');
  if (token) {
    setToken(token);
    params.delete('token');
    const newSearch = params.toString();
    const newURL = window.location.pathname + (newSearch ? `?${newSearch}` : '') + window.location.hash;
    window.history.replaceState({}, '', newURL);
  }
}

/**
 * Redirect the user to the SI login page, passing the current URL as the
 * redirect target so they come back here after logging in.
 */
export function redirectToLogin(): void {
  const redirect = encodeURIComponent(window.location.href);
  window.location.href = `${SI_LOGIN_URL}?redirect=${redirect}`;
}
